
import { DestroyRef, Injectable, inject, DOCUMENT } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { LanguageService } from '../../shared/service/language.service';
import { I18nNamespaceService } from './i18n-namespace.service';
import { DEFAULT_LANGUAGE } from './i18n.config';

const GLOBAL_NAMESPACES: readonly string[] = ['errors', 'shared'];

@Injectable({ providedIn: 'root' })
export class I18nInitService {
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly namespaceService: I18nNamespaceService = inject(
    I18nNamespaceService,
  );
  private readonly document: Document = inject(DOCUMENT);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly languageService: LanguageService = inject(LanguageService);

  public async init(): Promise<void> {
    this.syncDocumentLanguage();
    this.translate.setFallbackLang(DEFAULT_LANGUAGE);
    await firstValueFrom(
      this.translate.use(this.languageService.currentLanguage()),
    );
    await firstValueFrom(
      this.namespaceService.ensureLoaded(GLOBAL_NAMESPACES),
    );
  }

  private syncDocumentLanguage(): void {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (event: LangChangeEvent): void => {
          this.document.documentElement.lang = event.lang;
        },
        error: (): void => undefined,
      });
  }

}
